module.exports = __webpack_public_path__ + "media/images/interests/health-21579b3a242c88927f1d5abb9688a4f0.png";